import request from '@/utils/request'

export function cmsLinkListQuery() {
    return request({
        url: '/admin/cmsLinkListQuery',
        method: 'get',
    })
}
export function cmsConfigListQueryPage() {
    return request({
        url: '/admin/cmsConfigListQueryPage',
        method: 'get',
    })
}